import { render } from "./trust_compliance.html?vue&type=template&id=a032a49a&external"
import script from "./trust_compliance.js?vue&type=script&lang=js&external"
export * from "./trust_compliance.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__